<template>
  <div
    class="base-input"
    :class="{ error: hasValidationError }"
    :style="{ width }"
  >
    <label
      @click="() => !readonly && $refs.input.focus()"
      v-if="label && readonly"
      :class="['input__label', { readonly }]"
      >{{ label }}</label
    >

    <input
      :autocomplete="autocomplete ? 'on' : 'new-password'"
      ref="input"
      v-model="inputValue"
      @blur="handleBlur"
      @focus="$emit('focus')"
      :name="name"
      :placeholder="placeholder"
      :type="typeInput"
      class="input__field"
      :readonly="readonly"
      :disabled="disabled"
      @keydown="(evt) => $emit('keydown', evt)"
      @keyup="(evt) => $emit('keyup', evt)"
      @keypress="(evt) => $emit('keypress', evt)"
      :style="passwordStyle"
    />

    <svgicon
      @click="show = !show"
      :class="['icon', { show }]"
      :icon="show ? 'eye' : 'close_eye'"
      height="22px"
      :width="show ? '22px' : '20px'"
    />

    <slot v-if="hasValidationError && !serverValidationPending" />
  </div>
</template>

<script>
import Base from "./Base/Base";

export default {
  name: "vpassword",
  extends: Base,
  data() {
    return {
      show: false,
    };
  },
  computed: {
    typeInput() {
      return !this.show ? "password" : "text";
    },
    passwordStyle() {
      return {
        fontSize: !this.inputValue.length ? 'font-size:18px' : null,
        paddingRight: '40px'
      }
    }
  },
  methods: {
    handleBlur() {
      this.$emit("blur");
      this.validate();
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  position: absolute;
  right: 10px;
  top: 13.5px;
  fill: $gray;
  transition: fill 0.2s;
  cursor: pointer;

  @media screen and (max-width:1500px) {
    top: 8.5px;
  }
}

.show {
  fill: $blue;
}

.error {
  .icon {
    fill: $red;
  }
}
</style>
